import { useCallback } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { parseFormattedNumber } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useTaskCreate } from "../../hooks/mutations/useTaskMutation"
import { useProjectTaskTypes, useTaskTypes } from "../../hooks/queries/useTaskType"

import { RoadworkTaskForm } from "./RoadworkTaskForm"

export const RoadworkTaskAddFormPost = (props) => {

    const {
        roadwork,
        onClose,
        onSubmitting,
        onChange,
        ...formProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const {
        data: taskTypes,
        isLoading: isLoadingTaskTypes,
        isError: isErrorTaskTypes,
    } = useTaskTypes()

    const {
        data: projectTaskTypes,
        isLoading: isLoadingProjectTaskTypes,
        isError: isErrorProjectTaskTypes,
    } = useProjectTaskTypes()


    const roadworkTaskMutation = useTaskCreate({
        errorSnackbarMessage: t(I18N_NAMESPACE, "components.roadworkDetailsForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "components.roadworkDetailsForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: () => {
            onSubmitting(false)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            roadwork: roadwork.uuid,
            ...formValues,
            cost: parseFormattedNumber(formValues.cost),
            quantity: parseFormattedNumber(formValues.quantity),
        }
        roadworkTaskMutation.mutate(values)
        onSubmitting(true)
    }, [roadwork.uuid, roadworkTaskMutation, onSubmitting])

    if (isLoadingProjectTaskTypes || isLoadingTaskTypes) {
        return null
    }

    if (isErrorProjectTaskTypes || isErrorTaskTypes) {
        return null
    }

    return <RoadworkTaskForm
        isSubmitting={roadworkTaskMutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
        projectTasksInfo={projectTaskTypes}
        tasksInfo={taskTypes}
        {...formProps}
    />
}